var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c("w-card-title", [_vm._v("Script properties")]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("app-label", {
                    attrs: { label: "Name", value: _vm.script.Name },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("app-label", {
                    attrs: {
                      label: "Script Type",
                      value: _vm.script.ScriptType,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-row", { attrs: { "no-margin": "", center: "" } }, [
                    _c("h4", [_vm._v(" Standard args ")]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            _vm._l(_vm.script.StandardArgs, function (standardArg, i) {
              return _c(
                "w-row",
                { key: i },
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "10", lg: "8", xl: "6" } },
                    [
                      _c(
                        "w-row",
                        { attrs: { "no-margin": "" } },
                        [
                          _c("app-label", {
                            staticClass: "grow",
                            attrs: {
                              label: "Name",
                              value: _vm.script.StandardArgNames[i],
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-label", {
                        attrs: {
                          label: "Value",
                          value: _vm.script.StandardArgs[i],
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-row", { attrs: { "no-margin": "", center: "" } }, [
                    _c("h4", [_vm._v(" Extra args ")]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            _vm._l(_vm.script.ExtraArgNames, function (extraArg, y) {
              return _c(
                "w-row",
                { key: y },
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("app-label", {
                        staticClass: "grow",
                        attrs: {
                          label: "Name",
                          value: _vm.script.ExtraArgNames[y],
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c(
                        "w-row",
                        { attrs: { "no-margin": "" } },
                        [
                          _c("app-label", {
                            staticClass: "grow",
                            attrs: {
                              label: "Type",
                              value: _vm.script.ExtraArgTypes[y],
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", "no-margin": "" } },
                    [
                      _c("app-translation-info", {
                        model: {
                          value: _vm.script.ExtraArgUserFriendlyNames[y],
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.script.ExtraArgUserFriendlyNames,
                              y,
                              $$v
                            )
                          },
                          expression: "script.ExtraArgUserFriendlyNames[y]",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c("w-spacer"),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" Close ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }